import { StockProduct } from "../models/stock-product";
import { httpGet, httpPost } from "./http-client";

const apiUrl = '/api/stockproducts';

export const getStockProducts = () => httpGet<StockProduct[]>(apiUrl);
export const updateStockProductPurchasePrices = (stockProducts: StockProduct[]) => httpPost<StockProduct[]>(`${apiUrl}/updatepurchaseprices`, stockProducts);
export const updateStockProductPrices = (stockProducts: StockProduct[]) => httpPost<StockProduct[]>(`${apiUrl}/updateprices`, stockProducts);
